import React, { useEffect, useState } from "react";
import MainBg from "../../components/Mainbg";
import { Swiper, SwiperSlide, Navigation } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import {
  Tooltip,
  Cell,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  LineChart,
  Line,
} from "recharts";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { GET_TRACK_EAT } from "../../config/ApisCollection";
import BaseImage from "../../assets/images/dasboard/base.webp";
import tracknotfound from "../../assets/images/track-not-found.png";

import {
  monthlist,
  getDatesWithDayNames,
  WeekInMonth,
} from "../../function/functions";
import NutritionSection from "../../sections/NutritionSection";
import {
  DaySlideSection,
  DayWeekTabSection,
  NotFound,
  TrackDateFilterSection,
  WeekSlideSection,
} from "../../components/TrackCommonSection";

const EatTrack = ({ weekStart = "Sunday" }) => {
  const accessToken = secureLocalStorage.getItem("accessToken");
  // Update current date, month, and year on component mount
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed and should be 2 digits
  const day = String(now.getDate()).padStart(2, "0"); // Ensure day is 2 digits
  const current_date = `${year}-${month}-${day}`; // Ensure day is 2 digits
  // const dayOfWeek = now.getDay();
  const dayOfWeek = day;
  const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const firstWeekday = firstDayOfMonth.getDay(); // Day of the week for the 1st of the month
  // Get the current week of the month

  const currentWeekfind = Math.ceil((now.getDate() + firstWeekday) / 7); // Week number in the month

  // console.log(currentWeekfind);
  const [dataTab, setDataTab] = useState("Daily");
  const [bardata, setBarData] = useState([]);
  const [linedata, setLineData] = useState([]);
  const [activeDayTab, setActiveDayTab] = useState(current_date || null);
  const [activeWeekTab, setActiveWeekTab] = useState(currentWeekfind - 1);
  const [currentMonth, setCurrentMonth] = useState(month || null);
  const [currentYear, setCurrentYear] = useState(year || null);
  const [reportData, setReportData] = useState(null);
  const [mealPlan_data, set_mealPlan_data] = useState(null);

  const weeklist = ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"];
  // Function to get the current week with dates and day names

  const handleChange = (event) => {
    setCurrentMonth(event.target.value);
  };

  const GetTrackReport = async () => {
    const getParams = {
      month: currentMonth,
      year: currentYear,
    };

    const getHeaders = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.post(GET_TRACK_EAT, getParams, getHeaders);

      setReportData(response.data);
      lineDataPrep(response.data);
      set_mealPlan_data(response.data);
      let bar_data_arr = [];
      response?.data &&
        response?.data?.mealLogsweek?.[currentYear + "-" + currentMonth][
          "week" + (activeWeekTab + 1)
        ]?.dailyData?.forEach((item, index) => {
          const shortFormatedYmd = new Date(item?.date)?.toLocaleString(
            "en-US",
            {
              day: "numeric",
              month: "short",
            }
          );

          bar_data_arr.push({
            name: shortFormatedYmd,
            Calorie: item?.calori || 0,
          });
        });

      setBarData(bar_data_arr);

      // console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  // const currentWeek = getCurrentWeek(weekStart);
  const currentWeek = getDatesWithDayNames(year, currentMonth - 1);
  // console.log(dates);

  const lineDataPrep = (mealPlan_data) => {
    const shortFormatedYmd_activeDayTab = new Date(activeDayTab).toLocaleString(
      "en-US",
      {
        day: "numeric",
        month: "numeric",
        year: "numeric",
      }
    );
    let line_data_arr = [
      {
        Calorie: 0,
      },
    ];
    mealPlan_data?.mealLogs.forEach((meal_row, index) => {
      const shortFormatedYmd = new Date(meal_row?.logdate).toLocaleString(
        "en-US",
        {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        }
      );
      if (shortFormatedYmd == shortFormatedYmd_activeDayTab) {
        line_data_arr.push({ Calorie: meal_row.dietCal });
      }
    });
    setLineData(line_data_arr);
  };

  useEffect(() => {
    GetTrackReport();
  }, [activeDayTab, currentMonth, activeWeekTab, currentYear]);

  return (
    <MainBg>
      <div className="container lg:w-1/4 md:w-1/3 w-full m-auto">
        <TrackDateFilterSection
          currentMonth={currentMonth}
          month={month}
          year={year}
          monthlist={monthlist}
          setCurrentYear={setCurrentYear}
          currentYear={currentYear}
          handleChange={handleChange}
        />

        <DayWeekTabSection dataTab={dataTab} setDataTab={setDataTab} />
      </div>
      {dataTab === "Daily" ? (
        <>
          {/* Daily based data report  */}
          {/* Date and day tabs  */}
          <DaySlideSection
            activeDayTab={activeDayTab}
            currentWeek={currentWeek}
            dayOfWeek={dayOfWeek}
            setActiveDayTab={setActiveDayTab}
          />

          <>
            {/* Workout list set left  */}
            <div className="container mx-auto p-4 py-20">
              {linedata && linedata?.length >= 2 ? (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  {/* Table section  */}
                  <div>
                    <div className="">
                      <div className="col-span-2 px-0 sm:border-r-2 border-none">
                        <div className="grid xl:grid-cols-2 md:grid-cols-2 sm:grid-cols-2 grid-cols-2 gap-5">
                          {mealPlan_data &&
                            mealPlan_data !== "meal not genereted yet" &&
                            mealPlan_data !== null &&
                            Object.entries(mealPlan_data.mealLogs).length > 0 &&
                            Object.entries(mealPlan_data.mealLogs)?.map(
                              ([key, cl_row], index) => {
                                const formattedDate = new Date(
                                  cl_row?.logdate
                                ).toLocaleString("en-US", {
                                  weekday: "long",
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                  hour: "numeric",
                                  minute: "numeric",
                                  second: "numeric",
                                  hour12: true,
                                });
                                const shortFormatedYmd = new Date(
                                  cl_row?.logdate
                                ).toLocaleString("en-US", {
                                  day: "numeric",
                                  month: "numeric",
                                  year: "numeric",
                                });
                                const shortFormatedYmd_activeDayTab = new Date(
                                  activeDayTab
                                ).toLocaleString("en-US", {
                                  day: "numeric",
                                  month: "numeric",
                                  year: "numeric",
                                });

                                if (
                                  shortFormatedYmd ==
                                  shortFormatedYmd_activeDayTab
                                ) {
                                  return (
                                    <div key={index}>
                                      <div className="mt-5">
                                        <h1 className="font-bold">
                                          Meal {index + 1}
                                        </h1>
                                        <p className="text-[#7f7f7f] text-[12px]">
                                          {formattedDate}
                                        </p>
                                      </div>
                                      <div className="mt-2  ">
                                        <div className="melasbox" key={index}>
                                          <div>
                                            <img
                                              loading="lazy"
                                              src={cl_row.thumbnail}
                                              alt="meals1"
                                              className="mealsimg h-[206px]"
                                              height={145}
                                              width={145}
                                            />
                                          </div>
                                          <div className="melalin">
                                            <div>
                                              <span className="fastiweekboxtit">
                                                {" "}
                                                {cl_row.dietCal + " Kcal"}
                                              </span>
                                              <span className="text-[#7f7f7f] text-capitalize text-[12px]">
                                                {" "}
                                                {" • "}
                                                {cl_row?.dietFrequency?.replace(
                                                  "_",
                                                  " "
                                                )}
                                              </span>
                                            </div>
                                            <div className="tabetsbol text-capitalize text-[14px]">
                                              {cl_row.dietTitle.slice(0, 80)}
                                            </div>
                                            <hr />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              }
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Line graph right section */}
                  <div className="md:px-20 py-10 mb-10">
                    <ResponsiveContainer width="100%" height={200}>
                      <LineChart width={300} height={100} data={linedata}>
                        <defs>
                          <radialGradient
                            id="radialGradient"
                            cx="50%"
                            cy="50%"
                            r="50%"
                            fx="50%"
                            fy="50%"
                          >
                            <stop offset="20%" stopColor="rgba(115,80,255,1)" />
                            <stop
                              offset="100%"
                              stopColor="rgba(255,153,80,1)"
                            />
                          </radialGradient>
                        </defs>
                        <Line
                          type="monotone"
                          dataKey="Calorie"
                          stroke="url(#radialGradient)" // Use the radial gradient here
                          strokeWidth={5}
                        />
                        <Tooltip />
                        <XAxis />
                      </LineChart>
                    </ResponsiveContainer>
                    <div className=" md:w-4/4 w-full mt-10">
                      <NutritionSection
                        setIsMealLogOpen={null}
                        nutritionData={mealPlan_data}
                        pageName={"eattrack"}
                      />
                    </div>
                  </div>
                  {/* ----------- */}
                </div>
              ) : (
                reportData && <NotFound />
              )}
            </div>
          </>
        </>
      ) : (
        <>
          {/* Weekly active tab  */}
          <WeekSlideSection
            weeklist={weeklist}
            activeWeekTab={activeWeekTab}
            setActiveWeekTab={setActiveWeekTab}
            currentWeekfind={currentWeekfind}
          />
          <div className="container mx-auto p-4 py-20">
            {bardata && bardata?.length > 0 ? (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {/* Table section  */}

                <div>
                  {reportData &&
                    reportData?.mealLogsweek &&
                    reportData?.mealLogsweek?.[
                      currentYear + "-" + currentMonth
                    ] &&
                    reportData?.mealLogsweek?.[
                      currentYear + "-" + currentMonth
                    ]["week" + (activeWeekTab + 1)]?.dailyData?.map(
                      (week_day, index) => {
                        const shortFormatedYmd = new Date(
                          week_day?.date
                        ).toLocaleString("en-US", {
                          day: "numeric",
                          month: "short",
                        });
                        return (
                          <div key={index}>
                            <div className="flex border-b justify-between	items-center">
                              <div className="p-2 text-capitalize">
                                <p>
                                  {/* {week_day?.date},{currentMonth} */}
                                  {shortFormatedYmd}
                                </p>
                              </div>
                              {week_day?.calori ? (
                                <div className="flex">
                                  <div className="p-2">
                                    <p className="font-bold">
                                      {week_day?.calori} cal
                                    </p>
                                    <div className="text-xs flex items-center gap-1">
                                      <div className="h-[8px] w-[8px] bg-[#FE7701] rounded-full"></div>{" "}
                                      Consumed
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <>No record</>
                              )}
                            </div>
                          </div>
                        );
                      }
                    )}
                </div>

                {/* Graph section */}
                <div>
                  <div>
                    <span className="text-[#FE7701] text-[24px]">
                      {reportData?.mealLogsweek?.[
                        currentYear + "-" + currentMonth
                      ] &&
                        reportData?.mealLogsweek?.[
                          currentYear + "-" + currentMonth
                        ]["week" + (activeWeekTab + 1)]?.total}{" "}
                      kcal
                    </span>{" "}
                    <span className="text-[#000] text-[24px]">consumed</span>
                  </div>
                  <p className="text-[#7f7f7f] text-[12px]">
                    Data from your eating logs{" "}
                  </p>
                  <ResponsiveContainer width="100%" height="80%">
                    <BarChart
                      width={500}
                      height={300}
                      data={bardata}
                      margin={{
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 5,
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      {/* <YAxis /> */}
                      {/* <Tooltip /> */}
                      <Legend />
                      <Bar dataKey="Calorie" stackId="a" fill="#FF9950" />
                      {/* <Bar dataKey="Eating" stackId="a" fill="#ffeee2" /> */}
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
            ) : (
              <NotFound />
            )}
          </div>
        </>
      )}
    </MainBg>
  );
};

export default React.memo(EatTrack);
